export const readTime = (content) => {
  const words = (content || '').trim().split(/\s+/).filter(Boolean).length;
  return Math.max(1, Math.round(words / 200));
};

export const difficultyTag = (d) => {
  switch ((d || '').toLowerCase()) {
    case 'beginner': return { label: 'Beginner', cls: 'tag-muted' };
    case 'intermediate': return { label: 'Field Test', cls: 'tag-steel' };
    case 'advanced': return { label: 'Advanced', cls: 'tag-amber' };
    case 'experimental': return { label: 'Experimental', cls: 'tag-teal' };
    default: return { label: d || 'Log', cls: 'tag-muted' };
  }
};

const STATUS = {
  VERIFIED: { label: 'Reviewed', cls: 'tag-teal' },
  EXPERIMENTAL: { label: 'Experimental', cls: 'tag-steel' },
  'FIELD TEST': { label: 'Field Test', cls: 'tag-steel' },
  ARCHIVED: { label: 'Archived', cls: 'tag-muted' },
  'IN PROGRESS': { label: 'In Progress', cls: 'tag-amber' },
  THEORETICAL: { label: 'Theoretical', cls: 'tag-muted' },
};

export const statusTag = (s) => STATUS[(s || '').toUpperCase()] || { label: s || 'Logged', cls: 'tag-muted' };

export const CONTENT_TYPES = [
  'Field Note', 'Research Summary', 'Prototype Guide', 'Experiment Log',
  'Measurement Report', 'Blueprint', 'Archived Theory', 'Lab Observation', 'Materials Study',
];

export const STATUS_OPTIONS = ['VERIFIED', 'EXPERIMENTAL', 'FIELD TEST', 'ARCHIVED', 'IN PROGRESS', 'THEORETICAL'];

export const isExperiment = (a) => {
  const st = (a.status || '').toUpperCase();
  const ct = (a.content_type || '').toLowerCase();
  return (
    st === 'EXPERIMENTAL' || st === 'IN PROGRESS' || st === 'FIELD TEST' ||
    /experiment|observation|measurement/.test(ct)
  );
};

const norm = (s) => (s || '').toLowerCase().trim();

// Resolve a reference string to an internal article when its title matches.
export const matchInternalRef = (ref, articles) => {
  const r = norm(ref);
  if (!r) return null;
  return (
    articles.find((a) => norm(a.title) === r) ||
    articles.find((a) => norm(a.title).length > 12 && (r.includes(norm(a.title)) || norm(a.title).includes(r))) ||
    null
  );
};

// Classify a reference: internal archive record, external URL, or styled source note.
export const classifyReference = (ref, articles) => {
  const internal = matchInternalRef(ref, articles);
  if (internal) return { kind: 'internal', article: internal };
  if (/^https?:\/\//i.test((ref || '').trim())) return { kind: 'external' };
  return { kind: 'source' };
};
